<script>

//const apiSrc = "https://enjoykaohsiung.thinker.tw";
//const subDirectory = "/Platform";

const apiSrc = "https://men-go.tw";
const subDirectory = "/Platform";

//const apiSrc = "https://localhost:44320";
//const subDirectory = "";

const QRCId = 31;
//const tripPlanningHost = "https://qa-citygpt.foxconn.com/ibusweb";
const tripPlanningHost = "https://ibusplus.tbkc.gov.tw";
const localVer = "20260922.02";
export default {
  apiSrc,
  subDirectory,
  localVer,
  QRCId,
  tripPlanningHost
};
</script>



// WEBPACK FOOTER //
// src/components/Global.vue